import { useState, useContext, useEffect } from "react";
import FilterContexts from "../../Variables/FilterContexts";
import { jwtDecode } from "jwt-decode";

function SearchPane() {
    const {datas ,updateFunc} = useContext(FilterContexts);
    const [temDatas, setTemDatas] = useState(datas);
    const propertyList = Object.keys(datas);
    const [identity, setIdentity] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('token');
        try {
            const decoded = jwtDecode(token);
            // console.log(decoded.data.role);
            setIdentity(decoded.data.role);
        } catch (error) {
            console.error("無法解碼 JWT:", error);
        }
    }, [])

    const updateFilter = (event) => {
        setTemDatas(prevState => ({
            ...prevState,
            [event.target.name]: event.target.value
        }));
    }

    const applyFilter = () => {
        propertyList.map(key => {
            return updateFunc(key, temDatas[key]);
        })
    }

    const switchPage = (target) => {
        let nextPage = Math.max(1, parseInt(temDatas.page==='' ? 1 : temDatas.page, 10)+target);
        // setTemDatas(prevState => ({
        //     ...prevState,
        //     page: nextPage
        // }));
        updateFunc('page', nextPage)
    }

    const clearFilter = () => {
        propertyList.forEach(key => {
            setTemDatas(prevState => ({
                ...prevState,
                [key]: ''
            }));
            updateFunc(key,'');
        })
    }

    useEffect(() => {
        propertyList.forEach(key => {
            setTemDatas(prevState => ({
                ...prevState,
                [key]: datas[key]
            }));
        })
    }, [datas])

    return (
        identity === 'admin' ? (
            <table className="w-3/4 text-2xl m-auto border-separate border-spacing-y-2">
                <tr>
                    <td colSpan={2}><div className="text-center"><label htmlFor="name" className="">搜尋姓名</label></div></td>
                    <td colSpan={2}><div className="flex"><input name="name" type="test" className="px-1 bg-[#fff] border rounded-xl w-3/4 m-auto" onChange={(event) => updateFilter(event)} value={temDatas.name}></input></div></td>
                </tr>
                <tr>
                    <td colSpan={2}><div className="text-center"><label htmlFor="patientId">搜尋身分證</label></div></td>
                    <td colSpan={2}><div className="flex"><input name="patientId" type="test" className="px-1 bg-[#fff] border rounded-xl w-3/4 m-auto" onChange={(event) => updateFilter(event)} value={temDatas.patientId}></input></div></td>
                </tr>
                <tr>
                    <td className="text-right"><label htmlFor="perpage" className="">每頁
                        <input name="perpage" type="number" max={50} className="px-1 bg-[#fff] border rounded-xl w-12 m-auto" onChange={(event) => updateFilter(event)} value={temDatas.perpage}></input>
                    筆</label></td>
                    <td className="text-center"><label htmlFor="page" className=""> 第
                        <input name="page" type="number" className="px-1 bg-[#fff] border rounded-xl w-12 m-auto" onChange={(event) => updateFilter(event)} value={temDatas.page}></input>
                    頁</label></td>
                    <td className="text-right"><button onClick={() => applyFilter()} className="p-2 bg-[#2a4cf4] text-[#fff] rounded-lg pl-6 pr-6">篩選</button></td>
                    <td className="text-center"><button onClick={() => clearFilter()} className="p-2 bg-[#f42a2a] text-[#fff] rounded-lg pl-6 pr-6">清空篩選</button></td>
                </tr>
                <tr>
                    <td colSpan={2}></td>
                    <td className="text-right"><button onClick={() => switchPage(parseInt(-1, 10))} className="pr-6 text-xl">上一頁</button></td>
                    <td className="text-center"><button onClick={() => switchPage(parseInt(1, 10))} className="p-2 text-xl">下一頁</button></td>
                </tr>
            </table>
            // <div className="bg-[#ddd] w-full text-xl">
            //     <button onClick={() => switchPage(parseInt(-1, 10))} className="p-2 text-xl">上一頁</button>
            //     <button onClick={() => switchPage(parseInt(1, 10))} className="p-2 text-xl">下一頁</button>
            //     <br></br>
            // </div>

        ) : <></>
    )
}

export default SearchPane;